module.exports = __webpack_public_path__ + "static/sample-11-67832eeeb13e09f839acb12b24855648.png";